<div class="main_body">
  <app-page-header
    [title]="pageTitle"
    i18n-title="@@adminSystem.distributorList.title.list"
    subtitle="代理店の新規作成、情報の閲覧・編集を行います。"
    i18n-subtitle="@@adminSystem.distributorList.label.description"
    icon="admin"
  />
  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="table-toolbar">
          <!-- M3 Expandable Search Pill -->
          <div
            class="search-pill"
            [class.expanded]="searchExpanded()"
            [class.has-value]="filter.trim()"
            (click)="expandSearch()"
            role="search"
          >
            <mat-icon class="search-pill__icon">search</mat-icon>
            @if (!searchExpanded() && !filter.trim()) {
              <span class="search-pill__placeholder" i18n="@@adminSystem.distributorList.placeholder.filter">代理店名 フィルター</span>
            }
            <input
              #searchInput
              type="text"
              class="search-pill__input"
              [value]="filter"
              (input)="applyFilter($event)"
              (blur)="onSearchBlur()"
              [attr.aria-label]="'代理店名 フィルター'"
              i18n-aria-label="@@adminSystem.distributorList.search.ariaLabel"
            />
            @if (filter.trim()) {
              <button
                type="button"
                class="search-pill__clear"
                (click)="clearSearch($event)"
                aria-label="検索をクリア"
                i18n-aria-label="@@adminSystem.distributorList.search.clearAriaLabel"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
          <!-- Action buttons - right aligned -->
          <div class="table-toolbar__actions">
            @if (hasSystemAdminManagement) {
              <button mat-stroked-button
                      class="list-action-button"
                      (click)="openDistributorDetailsDialog()">
                <span i18n="@@adminSystem.sectionGroupList.button.create">新規作成</span>
                <mat-icon>add</mat-icon>
              </button>
              <!-- <button
                mat-icon-button
                class="table-toolbar__btn"
                (click)="inviteAdmin()"
                matTooltip="管理者招待"
                aria-label="管理者招待"
                i18n-matTooltip="@@adminSystem.systemAdminList.tooltip.inviteAdmin"
                i18n-aria-label="@@adminSystem.systemAdminList.ariaLabel.inviteAdmin"
              >
                <mat-icon>person_add</mat-icon>
              </button> -->
            }
            <button
              mat-icon-button
              class="table-toolbar__btn"
              (click)="refreshData()"
              matTooltip="更新"
              aria-label="更新"
              i18n-matTooltip="@@adminSystem.systemAdminList.tooltip.refresh"
              i18n-aria-label="@@adminSystem.systemAdminList.ariaLabel.refresh"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>

        <div class="user-list-container mat-elevation-z0">
          @if (isLoading()) {
            <app-table-skeleton [rows]="5" />
          } @else {
            <table class="entry-table staff" mat-table [dataSource]="dataSource" matSort matSortActive="status" matSortDirection="desc">

              <ng-container matColumnDef="name" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="sticky-left-column" i18n="@@adminSystem.systemAdminList.table.name"> 代理店名 </th>
                <td mat-cell *matCellDef="let row" class="sticky-left-column">
                  @if (row.userId == loginUserId) {
                    {{row.name}}<span class="status-badge status-badge--active">You</span>
                  } @else {
                    <span>{{row.name}}</span>
                  }
                </td>
              </ng-container>
              
              <ng-container matColumnDef="numOfSectionGroups">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 90px;" i18n="@@adminSystem.systemAdminList.table.numOfSectionGroups"> セクショングループ数 / 最大数 </th>
                <td mat-cell *matCellDef="let row">
                  {{ distributorSectionGroupCountMap[row.id] ?? 0 }}/{{row.maxSectionGroups}}
                </td>
              </ng-container>

              <!-- <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 90px;" i18n="@@adminSystem.systemAdminList.table.status"> ステータス </th>
                <td mat-cell *matCellDef="let row">
                  @if (row.status == 'OPEN') {
                    <span class="status-badge status-badge--active">{{accountStatus[row.status]}}</span>
                  } @else {
                    <span class="status-badge status-badge--inactive">{{accountStatus[row.status]}}</span>
                  }
                </td>
              </ng-container> -->

              <!-- <ng-container matColumnDef="assignedDate" stickyEnd>
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="sticky-end-column" i18n="@@adminSystem.systemAdminList.table.assignedDate"> 管理開始日 </th>
                <td mat-cell *matCellDef="let row" class="sticky-end-column table-cell-date"> {{row.assignedDate}} </td>
              </ng-container> -->

              <!-- <ng-container matColumnDef="stop" stickyEnd>
                <th mat-header-cell *matHeaderCellDef class="actions-header"></th>
                <td mat-cell *matCellDef="let row" class="actions-cell">
                  <div class="staff-actions-group">
                    @if (row.status === 'OPEN') {
                      <button
                        mat-icon-button
                        class="staff-action-button staff-action-button--danger"
                        (click)="openStaffActivationDialog(row.id)"
                        matTooltip="アカウント停止"
                        i18n-matTooltip="@@adminSystem.systemAdminList.tooltip.deactivate"
                        aria-label="アカウント停止"
                        i18n-aria-label="@@adminSystem.systemAdminList.ariaLabel.deactivate"
                      >
                        <mat-icon class="staff-action-icon">person_off</mat-icon>
                      </button>
                    }
                    @if (row.status === 'CLOSE') {
                      <button
                        mat-icon-button
                        class="staff-action-button staff-action-button--success"
                        (click)="openStaffActivationDialog(row.id)"
                        matTooltip="アカウント再開"
                        i18n-matTooltip="@@adminSystem.systemAdminList.tooltip.activate"
                        aria-label="アカウント再開"
                        i18n-aria-label="@@adminSystem.systemAdminList.ariaLabel.activate"
                      >
                        <mat-icon class="staff-action-icon">how_to_reg</mat-icon>
                      </button>
                    }
                  </div>
                </td>
              </ng-container> -->

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                [class.row-self]="loginUserId === row.id"
                [class.row-closed]="row.status === 'CLOSE'"
                (click)="openDistributorDetailsDialog(row)">
              </tr>
            </table>
          }
        </div>
        <mat-paginator class="user-list-paginator" [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50, 100]"></mat-paginator>
      </section>
    </div>
    <!--/contents_section_group-->
  </div>
  <!--/contents-->
</div>
